import axios from 'axios'
import { API_UPLOAD } from 'utils/constants'
import Api from './axiosInstance'

export interface GetPresignedUrlPayload {
  module: string
  fileName: string
  fileType: string
}

export interface PresignedUrlResult {
  key: string
  url: string
  expiresIn: number
}

export const getPresignedUploadUrl = async (
  payload: GetPresignedUrlPayload,
): Promise<PresignedUrlResult> => {
  const { data } = await Api.post({
    url: API_UPLOAD.PRESIGNED_URL,
    data: payload,
  })
  return data
}

interface UploadToS3Options {
  uploadUrl: string
  file: File
  onProgress?: (progress: number) => void
}

export const uploadFileToPresignedUrl = async ({
  uploadUrl,
  file,
  onProgress,
}: UploadToS3Options) => {
  return axios.put(uploadUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (!onProgress || !progressEvent.total) return

      const percent = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total,
      )

      onProgress(percent)
    },
  })
}
